const SCREENS = {
  HOME: 'HOME',
  ORDER: 'PEDIDO',
  MANAGE: 'GERENCIAMENTO',
  ND_MANAGE: 'GERENCIAMENTOND',
  EXTRA_VOLUME: 'VOLUMEEXTRA',
  OV: '100_ORDE_VEND',
  BACKOFFICE_RANGE: 'PARAMETROALCADA',
  RANKING: 'RANKING',
  INTERNATIONAL_EDI: '160_PRCS_EDI',
  FRANCHISES_BATCH: '113_PRCS_ORDE_VEND',
  TECHNICAL_CONSULTATION: 'CONSULTA_TECNICA'
} as const

const ACTIONS_SCREENS = {
  NULL: null,
  SUMMARY: 'RESUMO',
  EDIT: 'EDITAR',
  REQUEST: 'SOLICITAR',
  DOWNLOAD: 'DOWNLOAD',
  APPROVE: 'APROVAR',
  DISMISS: 'REPROVAR',
  CANCEL: 'CANCELAR',
  GIVE_BACK: 'DEVOLVER',
  DUPLICATE: 'DUPLICAR',
  SEND: 'ENVIAR',
  DELETE: 'EXCLUIR',
  SAVE: 'SALVAR',
  LIST: 'LISTA_HIER',
  RETURN: 'SOLI_RETN',
  PROCESS: 'PROCESSAR'
} as const

export { SCREENS, ACTIONS_SCREENS }
